/* Nourae Beauty - quantity tiers on the product page.
   Selecting a tier writes the quantity into the theme's product form so the
   cash-on-delivery form picks the same number up. */
(function () {
  'use strict';

  function setQuantity(qty) {
    var written = false;
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = qty;
      input.setAttribute('value', qty);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      written = true;
    });
    return written;
  }

  function init() {
    var wrap = document.querySelector('[data-nr-bundle]');
    if (!wrap || wrap.getAttribute('data-nr-bound')) return;
    wrap.setAttribute('data-nr-bound', '1');

    var tiers = wrap.querySelectorAll('[data-nr-tier]');
    if (!tiers.length) return;

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        tiers.forEach(function (other) {
          other.classList.remove('is-active');
          other.setAttribute('aria-checked', 'false');
        });
        tier.classList.add('is-active');
        tier.setAttribute('aria-checked', 'true');
        setQuantity(tier.getAttribute('data-nr-tier'));
      });
    });

    // Re-apply once the cash-on-delivery form has injected its own fields.
    var tries = 0;
    var poll = window.setInterval(function () {
      tries++;
      var active = wrap.querySelector('.nr-tier.is-active');
      if (active) setQuantity(active.getAttribute('data-nr-tier'));
      if (tries > 40) window.clearInterval(poll);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
